export default "__VITE_ASSET__B$RUWzsn__"